import { Component, Inject, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';

@Component({
  selector: 'app-home-create-announcement-popup',
  templateUrl: './home-create-announcement-popup.component.html',
  styleUrls: ['./home-create-announcement-popup.component.scss'],
})
export class HomeCreateAnnouncementPopupComponent  implements OnInit {
  loggedInUserCompanyID:any;
  buttonColorName:any;
  loggedInUserRole:any;
  AnnouncementName:any;
  AnnouncementSubject:any;
  AnnouncementId:any;
  AnnouncementDescription:any;
  isInvalidAnnouncementName:boolean = false;
  isInvalidAnnouncementSubject:boolean = false
  isInvalidAnnouncementDescription:boolean = false;
  
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<HomeCreateAnnouncementPopupComponent>,
    private encryptionService: EncryptionService, private httpService: HttpService,   private config: Config,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.AnnouncementName = this.data?.name;
    this.AnnouncementSubject = this.data?.subject;
    this.AnnouncementDescription = this.data?.body;
    this.AnnouncementId = this.data.id
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
  }

  editorConfig: AngularEditorConfig = { 
    editable: true,
      spellcheck: true,
      height: '350px',
      minHeight: '0',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Enter Announcement Here...',
      defaultParagraphSeparator: '',
  }

  stripHtmlTags(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.innerText;
  }

  isInvalidAnnouncement(){
    this.isInvalidAnnouncementName = !this.AnnouncementName?.trim();
    this.isInvalidAnnouncementSubject = !this.AnnouncementSubject?.trim();
    this.isInvalidAnnouncementDescription = !this.AnnouncementDescription?.trim();
  }

  onClickSaveAnnouncement(){
    this.isInvalidAnnouncement();
    if(!this.isInvalidAnnouncementName && !this.isInvalidAnnouncementSubject && !this.isInvalidAnnouncementDescription){
      this.isInvalidAnnouncementName = false;
      this.isInvalidAnnouncementSubject = false;
      this.isInvalidAnnouncementDescription = false;
      const LetterTextContent = this.stripHtmlTags(this.AnnouncementDescription);
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Announcement successfully Added',
          btn1: 'Cancel',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe((result:any) => {
        if (result) { 
          const request = {
            "body": this.AnnouncementDescription,
            "companyId": this.loggedInUserCompanyID,
            "id": this.AnnouncementId || null,
            "name": this.AnnouncementName,
            "subject": this.AnnouncementSubject
          }
          this.httpService.callPostService(this.config.setAnnouncement, request).subscribe((result:any)=>{
            if(result){
              this.dialogRef.close(); 
            }
          })
        }
      });      
    }
  }
}
